export interface IReadyToCloseEvent {
  method?: string;
  params?: {
    type: string;
    data?: {
      name?: string;
    };
  };
}

/* eslint-disable no-unused-vars */
export enum LinkOpeningSetting {
  ASK_EVERY_TIME = "askEveryTime",
  ALWAYS_IN_APP = "alwaysInApp",
  ALWAYS_IN_BROWSER = "alwaysInBrowser"
}
